<template>
  <div>
    <v-autocomplete
      label="Mix with..."
      v-model="selected"
      :items="rows"
      item-value="id"
      :item-text="
        item =>
          `${item.ratePlanID} - ${item.ratePlanDescription || ''} (${
            item.contractMonths
          } months)`
      "
      multiple
      outlined
      class="pt-0"
      @input="$emit('mixwith', selected)"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip>
          <span>{{ item.ratePlanID }} - {{ item.ratePlanDescription }}</span>
        </v-chip>
      </template>
      <template v-slot:append-outer>
        <v-btn small icon @click="$emit('mixwith', selected)">
          <v-icon>
            assignment_return
          </v-icon>
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "rateplanAutocomplete",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("orders/ratePlan", ["rows"])
  },
  mounted() {
    if (this.item.mixWith) {
      this.selected = this.item.mixWith;
    }
  },
  data() {
    return {
      selected: []
    };
  }
};
</script>

<style lang="scss" scoped></style>
